module.exports = __webpack_public_path__ + "static/tutti-5b318343520f41b712635891cf549e7d.png";